export type AddMyPlaceStep =
  | 'address'
  | 'building'
  | 'size'
  | 'rooms'
  | 'publish'
  | 'share';

export type BuildingTypeValue =
  | 'apartment_building'
  | 'terraced_house'
  | 'duplex'
  | 'detached_house'
  | 'other';

export type RenovationStatus =
  | ''
  | 'recently_renovated'
  | 'good_condition'
  | 'needs_renovation';

export interface AddMyPlaceFormState {
  address: string;
  area: string;
  postal: string;
  buildingType: BuildingTypeValue;
  size: string;
  rooms: string;
  description: string;
  floor: string;
  renovationStatus: RenovationStatus;
  hasElevator: boolean | null;
  hasBalcony: boolean | null;
  askingPrice: string;
}

export const createInitialFormState = (): AddMyPlaceFormState => ({
  address: '',
  area: '',
  postal: '',
  buildingType: 'apartment_building',
  size: '',
  rooms: '',
  description: '',
  floor: '',
  renovationStatus: '',
  hasElevator: null,
  hasBalcony: null,
  askingPrice: '',
});

// Sensible fallbacks so empty input still renders a believable card, matching
// the Figma mock ("Vanha Talvitie 31, Kalasatama", 79 m2, 4 rooms).
export const DEFAULT_ADDRESS = 'Vanha Talvitie 31';
export const DEFAULT_AREA = 'Kalasatama';
export const DEFAULT_POSTAL = '00580 Helsinki';
export const DEFAULT_SIZE = '79';
export const DEFAULT_ROOMS = '4';

export const MAX_PROPERTY_DESCRIPTION_LENGTH = 1100;
export const MAX_PROPERTY_SIZE = 1000;
export const MAX_PROPERTY_FLOOR = 100;
// The lowest asking price a sell listing can be saved with (JAA-458); the
// backend enforces the same floor as MIN_SELL_ASKING_PRICE. Empty stays valid.
export const MIN_ASKING_PRICE = 1000;

export const clampPropertySizeInput = (value: string): string => {
  const digits = value.replace(/[^\d]/g, '');
  if (digits === '') return '';

  return String(Math.min(Number(digits), MAX_PROPERTY_SIZE));
};

export const clampPropertyFloorInput = (value: string): string => {
  const normalized = value.replace(/[^\d-]/g, '').replace(/(?!^)-/g, '');
  if (normalized === '' || normalized === '-') return normalized;

  return String(Math.min(Number(normalized), MAX_PROPERTY_FLOOR));
};
